import { memo, ReactElement } from 'react';
import { FilterPanelFooterLayout } from './FilterPanelLayout';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export interface FilterPanelFooterProps {
  onReset: () => unknown;
  itemCount?: number;
}

export const FilterPanelFooter = memo(function ({ onReset, itemCount }: FilterPanelFooterProps): ReactElement {
  return (
    <FilterPanelFooterLayout>
      <Button variant='outlined' color='primary' sx={{ flex: 1, m: 1 }} onClick={onReset}>
        Zurücksetzen
      </Button>
      <Typography sx={{ flex: 1, m: 1 }} variant='body1' align='center'>
        {itemCount !== undefined ? itemCount : '-'} Einträge
      </Typography>
    </FilterPanelFooterLayout>
  );
});
